import { Position } from '__generated__/globalTypes';
import { BaseballCatcher } from 'assets/icons/BaseballCatcher';
import { BaseballCornerInfielder } from 'assets/icons/BaseballCornerInfielder';
import { BaseballDesignatedHitter } from 'assets/icons/BaseballDesignatedHitter';
import { BaseballFirstBase } from 'assets/icons/BaseballFirstBase';
import { BaseballFlex } from 'assets/icons/BaseballFlex';
import { BaseballHitter } from 'assets/icons/BaseballHitter';
import { BaseballMiddleInfielder } from 'assets/icons/BaseballMiddleInfielder';
import { BaseballOutfielder } from 'assets/icons/BaseballOutfielder';
import { BaseballReliefPitcher } from 'assets/icons/BaseballReliefPitcher';
import { BaseballSecondBase } from 'assets/icons/BaseballSecondBase';
import { BaseballShortStop } from 'assets/icons/BaseballShortStop';
import { BaseballStartingPitcher } from 'assets/icons/BaseballStartingPitcher';
import { BaseballThirdBase } from 'assets/icons/BaseballThirdBase';
import { DefaultPosition } from 'assets/icons/DefaultPosition';
import { anyBaseballPositions, anyHitterPositions } from 'lib/baseball';
import type { unitMapping } from 'lib/style';

const mapKey = (positions: Nullable<Position>[]) =>
  [...(positions || [])].sort().join(',');

const knownSlots = {
  [mapKey([Position.baseball_starting_pitcher])]: BaseballStartingPitcher,
  [mapKey([Position.baseball_relief_pitcher])]: BaseballReliefPitcher,
  [mapKey([Position.baseball_first_base])]: BaseballFirstBase,
  [mapKey([Position.baseball_second_base])]: BaseballSecondBase,
  [mapKey([Position.baseball_third_base])]: BaseballThirdBase,
  [mapKey([Position.baseball_designated_hitter])]: BaseballDesignatedHitter,
  [mapKey([Position.baseball_catcher])]: BaseballCatcher,
  [mapKey([Position.baseball_shortstop])]: BaseballShortStop,
  [mapKey([
    Position.baseball_first_base,
    Position.baseball_third_base,
    Position.baseball_designated_hitter,
  ])]: BaseballCornerInfielder,
  [mapKey([
    Position.baseball_second_base,
    Position.baseball_shortstop,
    Position.baseball_catcher,
  ])]: BaseballMiddleInfielder,
  [mapKey([Position.baseball_outfield])]: BaseballOutfielder,
  [mapKey(anyHitterPositions)]: BaseballHitter,
  [mapKey(anyBaseballPositions)]: BaseballFlex,
};

type Props = {
  positions: Nullable<Position>[];
  size?: keyof typeof unitMapping;
};

export const BaseballIcon = ({ positions, size }: Props) => {
  const positionKey = mapKey(positions);
  const Icon = knownSlots[positionKey] ?? DefaultPosition;

  return <Icon size={size} />;
};
